export const CallDirection = {
    DirectionInbound: "directionInbound",
    DirectionOutbound: "directionOutbound",
};
export const ConversationType = {
    TypeWebConference: "typeWebConference",
    TypeOther: "typeOther",
};
export const DropdownFilterValues = [...Object.values(CallDirection), ...Object.values(ConversationType)];
export const DropdownFilterKeys = {
    [CallDirection.DirectionInbound]: 'Incoming_',
    [CallDirection.DirectionOutbound]: 'Outgoing_',
    [ConversationType.TypeWebConference]: 'Web.conference_',
    [ConversationType.TypeOther]: 'Other_',
};
export const AiStatus = {
    Processing: "processing",
    Success: "success",
    Failed: "processing_failed",
};
export const AiFailureReason = {
    None: "None",
    LimitReached: "LimitReached",
    General: "General",
    Disabled: "Disabled",
};
